$(function() {
  $('.tape').marquee({
    duration: 18000,
    startVisible: true,
    duplicated: true,
    direction: 'right'
  });
});
